import jinRamyun from "../images/jin-ramyun.jpg";
import shinRamyun from "../images/shin-ramyun.jpg";

const products = [
    {
        id: "jinramyun",
        name: "Rabboki set w/ Jin ramyun",
        subtitle: "& your choice of binngrae",
        price: 280,
        description:
            "A Rabboki set with a savory pair of classic Jin ramyun and binggrae.",
        image: jinRamyun,
    },
    {
        id: "shinramyun",
        name: "Rabboki set w/ Shin ramyun",
        subtitle: "& your choice of binngrae",
        price: 280,
        description:
            "A Rabboki set with a delish combo of Shin ramyun and binngrae.",
        image: shinRamyun,
    },
];

export default products;